import {
  CompanyWithCollaborativesDto,
  CompanyWithCollaborativesPageDto,
} from "../../../types/company/company-dto";
import { convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives } from "../../../utils/converter/user/company-with-collaboratives-convertor";
import { CompanyState } from "../../type/company-state";

interface Action {
  type: string;
  payload: {
    companyWithCollaborativesPageDto: CompanyWithCollaborativesPageDto;
  };
}

export const setCompanyWithCollaborativesPageDispatch = (
  state: CompanyState,
  action: Action
) => {
  const { companyWithCollaborativesPageDto } = action.payload;

  state.companyWithCollaborativesPage = {
    contents: companyWithCollaborativesPageDto.contents.map(
      (companyWithCollaborativesDto: CompanyWithCollaborativesDto) => {
        return convertCompanyWithCollaborativesDtoToCompanyWithCollaboratives(
          companyWithCollaborativesDto
        );
      }
    ),
    first: companyWithCollaborativesPageDto.first,
    last: companyWithCollaborativesPageDto.last,
    page: companyWithCollaborativesPageDto.page,
    totalPages: companyWithCollaborativesPageDto.totalPages,
    totalElements: companyWithCollaborativesPageDto.totalElements,
  };
};
